function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 
 * @file Marker-based helper for the Box Groups API
 * @author Box
 */
import MarkerBasedAPI from './MarkerBasedAPI';
import { DEFAULT_MAX_CONTACTS, ERROR_CODE_FETCH_ENTERPRISE_GROUPS } from '../constants';

class MarkerBasedGroups extends MarkerBasedAPI {
  /**
   * API URL for fetching all groups that are visible to the current user
   *
   * @returns {string} URL for fetching groups
   */
  getUrl() {
    return "".concat(this.getBaseApiUrl(), "/groups");
  }
  /**
   * API for fetching all groups in the current user's enterprise
   *
   * @param {string} id - Box item ID
   * @param {Function} successCallback - Success callback
   * @param {Function} errorCallback - Error callback
   * @param {Object} [requestData] - Opitional additional request data
   * @param {Object} [limit] - Max number of groups to return
   * @returns {void}
   */


  getGroupsInEnterprise(id, successCallback, errorCallback, requestData) {
    let limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : DEFAULT_MAX_CONTACTS;
    this.errorCode = ERROR_CODE_FETCH_ENTERPRISE_GROUPS;
    this.markerGet({
      id,
      limit,
      successCallback,
      errorCallback,
      requestData: _objectSpread({
        usemarker: true
      }, requestData),
      shouldFetchAll: false
    });
  }

}

export default MarkerBasedGroups;
//# sourceMappingURL=MarkerBasedGroups.js.map